module.exports = __webpack_public_path__ + "static/media/FuzelCollage.ja.81a41994.svg";